import React from 'react';
import { NavigationItem as StyledNavigationItem } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../global/constants';

interface NavigationItemProps {
  iconName: string;
  onClick?: (e: React.SyntheticEvent) => void;
  width?: string;
  height?: string;
  viewBox?: string;
  fill?: string;
  disabled?: boolean;
}

const BottomNavigationItem: React.FC<NavigationItemProps> = ({
  iconName,
  onClick,
  width = ICON_SIZE.XXL,
  height = ICON_SIZE.XXL,
  viewBox = `0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`,
  fill = 'var(--text-primary)',
  disabled = false
}) => {
  return (
    <StyledNavigationItem role='button' onClick={onClick} disabled={disabled}>
      <SVGIcon name={iconName} width={width} height={height} viewBox={viewBox} fill={fill} />
    </StyledNavigationItem>
  );
};

export default BottomNavigationItem;
